import { ErrorHandling, formatNumberWithComma, getPayeeNotPOData, PayoutChecker, PayoutPopup, PulseOpsFormat, sharedStyle, SpecialBonusData, SubmissionService, TaskDetail, TaskDetailApi, Title } from '@pulseops/common'
import { FieldDescription, FieldText, SectionCol, SectionContent, SectionRow } from '@pulseops/submission/common'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { pipe } from 'fp-ts/lib/function'
import { ZIO } from '@mxt/zio'
import { useIsFocused } from '@react-navigation/native'
import { PayoutMethod } from './common'

type AutoTerminatedPolicyProps = {
detail: TaskDetail.VERSurrenderValuePaymentForAutoTerminatedPolicy
}

export const SurrenderValuePaymentForAutoTerminatedPolicy = (props: AutoTerminatedPolicyProps) => {
  const { t } = useTranslation()
  const isFocused = useIsFocused()
  const {detail} = props
  const SVAmount = pipe(
    ZIO.effect(() => {
      const accountGroups: SpecialBonusData.SBAccountGroups[] = [
        { sacsCode: 'LF', sacsType: 'TL' },
        { sacsCode: 'LP', sacsType: 'S' },
        { sacsCode: 'LF', sacsType: 'WF' }
      ]
      return accountGroups
    }),
    ZIO.flatMap((accountGroupInput) =>
      isFocused ? SubmissionService.getAccountBalance(detail.policyNumber || '', 'TOTAL', accountGroupInput) :
        ZIO.succeed({
          body: {
            accountGroups: [{
              amount: 0,
              sacsCode: '',
              sacsType: ''
            }]
          }
        })
    ),
    ZIO.map((accountBalance) => {
      const accountAmount = accountBalance.body.accountGroups?.reduce(function (total, item) {
        return total + item.amount
      }, 0) || 0
      return accountAmount
    }),
    ErrorHandling.runDidUpdate([isFocused])
  ) || 0

  const cashlessMethod = detail.methods.find(
    (x) => Object.values(PayoutPopup.CashlessMethod).findIndex((y) => y == x.method) >= 0
  )?.method

  const payoutData = {
    payPremium: detail.methods.findIndex((x) => PayoutChecker(PayoutPopup.PayoutMethods.PAYPREMIUM)(x.method)) >= 0,
    repayLoan: detail.methods.findIndex((x) => PayoutChecker(PayoutPopup.PayoutMethods.PAYLOAN)(x.method)) >= 0,
    otherPremium: detail.methods.findIndex((x) => PayoutChecker(PayoutPopup.PayoutMethods.OTHER)(x.method)) >= 0,
    cashless: !!cashlessMethod,
    cashlessMethod: cashlessMethod as PayoutPopup.CashlessMethod,
    totalPayoutAmount: formatNumberWithComma(detail.totalPayoutAmount),
    payouts: detail?.methods.map((x) => ({
      payoutMethod: x.method,
      detail: x.detail,
      amount: PulseOpsFormat.thousandSepartor(x.amount),
      status: x.status,
      note: x.note || '-'
    }))
  }

  const viewPayeeData = React.useMemo(() => {
    const viewData =
      detail && detail.cashOutList && detail.cashOutList.length > 0
        ? getPayeeNotPOData(detail.cashOutList as TaskDetailApi.PaymentData.CashOutList, detail.branchName ?? '')
        : undefined
    return viewData
  }, [detail.cashOutList])

  return (
    <View>
      <Title title={t('AutoTerminatedPolicy:VALUEPAYMENTFORAUTOTERMINATEDPOLICY')} wrapperStyle={sharedStyle.secondLine} />
      <SectionContent>
        <SectionRow>
          <SectionCol>
            <FieldText text={t('AutoTerminatedPolicy:SVAmount')}></FieldText>
            <FieldDescription text={formatNumberWithComma(SVAmount)} isCurrencyUnit
            ></FieldDescription>
          </SectionCol>
        </SectionRow>
      </SectionContent>
      <PayoutMethod payeeData={viewPayeeData} payoutMethodData={payoutData}></PayoutMethod>
    </View>
  )
}